// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconMail, IconLock, IconArrowLeft } from '@tabler/icons-react';
import { AuthLayoutWrapper, SocialLoginButtons } from '../components';

export default function LoginHeroImage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login attempt:', { email, password, rememberMe });
  };

  return (
    <AuthLayoutWrapper
      variant="cover"
      backgroundImage="https://images.unsplash.com/photo-1557683316-973673baf926?w=1920&q=80"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/login"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Logo/Brand */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 52,
                height: 52,
                borderRadius: 14,
                background: 'linear-gradient(135deg, #0ea5e9, #8b5cf6)',
              }}
            >
              <Text size="xl" fw={700} c="white">C</Text>
            </Center>
            <Title order={2} ta="center">Welcome back</Title>
            <Text c="dimmed" size="sm" ta="center">
              Sign in to continue to your account
            </Text>
          </Stack>
        </Center>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Email"
              placeholder="your@email.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <PasswordInput
              label="Password"
              placeholder="Your password"
              leftSection={<IconLock size={16} />}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <Group justify="space-between">
              <Checkbox
                label="Remember me"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.currentTarget.checked)}
              />
              <Anchor component={Link} to="/app/demo/auth-pages/forgot-password/cover" size="sm">
                Forgot password?
              </Anchor>
            </Group>

            <Button
              type="submit"
              fullWidth
              variant="gradient"
              gradient={{ from: 'cyan', to: 'violet' }}
            >
              Sign in
            </Button>
          </Stack>
        </form>

        {/* Social Login */}
        <SocialLoginButtons
          providers={['google', 'github']}
          layout="horizontal"
          variant="outline"
        />

        {/* Register Link */}
        <Text ta="center" size="sm">
          Don't have an account?{' '}
          <Anchor component={Link} to="/app/demo/auth-pages/register/cover" fw={500}>
            Sign up
          </Anchor>
        </Text>
      </Stack>
    </AuthLayoutWrapper>
  );
}
